//libs
import React, { memo } from 'react';

//components
import AdPlatformWidgetsDesktop from 'shared/components/AdPlatformWidgets/Desktop';
import ErrorComponent from 'shared/layouts/Listing/ErrorWrapperV2/components/ErrorComponent';

//defs
import { ILandingPageWidget } from 'shared/components/AdPlatformWidgets/types';
import { ErrorDetails } from 'shared/layouts/Listing/ErrorWrapperV2/types';

interface AdPlatformErrorPageProps {
  emptyWidgetEnabled: boolean;
  widgets: ILandingPageWidget[];
  errorDetails: ErrorDetails;
  onButtonClick?: VoidFunction;
}

function AdPlatformErrorPage({
  emptyWidgetEnabled = false,
  widgets = [],
  errorDetails,
  onButtonClick,
}: AdPlatformErrorPageProps) {
  if (emptyWidgetEnabled && widgets.length)
    return <AdPlatformWidgetsDesktop landingPageData={widgets} />;

  return <ErrorComponent errorDetails={errorDetails} onButtonClick={onButtonClick} />;
}

export default memo(AdPlatformErrorPage);
